import { Route, Routes } from 'react-router-dom';
import './App.css';
import Dashboard from "./Pages/Dashboard";
import UploadForm from "./Components/Twilio/SendWsp";
import Login from "../src/Pages/Login/Login";
import NotFound from "./Pages/NotFound"; // Importa la página 404

function App() {
  return (

      <Routes>
        <Route path='/' element={<Dashboard />} />
        <Route path='/login' element={<Login />} />
        <Route path='/profile' element={<Dashboard />} />
        <Route path='/create-user' element={<Dashboard />} />
        <Route path='/contacts' element={<Dashboard />} />
        <Route path='/contacts/:id' element={<Dashboard />} />
        <Route path='/add-contacts' element={<Dashboard />} />
        {/* <Route path='/contacts' element={<ProtectedRoute > <Contacts /> </ProtectedRoute>} /> */}
        <Route path='/asesores' element={<Dashboard />} />
        <Route path='/asesores/:id' element={<Dashboard />} />
        <Route path='/ventas' element={<Dashboard />} />
        <Route path='/seguimientos' element={<Dashboard />} />
        <Route path='/seguimientos/:id' element={<Dashboard />} />
        <Route path='/productores' element={<Dashboard />} />
        <Route path='/productores/:id' element={<Dashboard />} />
        <Route path='/clientes' element={<Dashboard />} />
        <Route path='/clientes/:id' element={<Dashboard />} />
        <Route path='/cotizador' element={<Dashboard />} />
        <Route path='/agenda' element={<Dashboard />} />
        <Route path='/cobranza' element={<Dashboard />} />
        <Route path='/organizaciones' element={<Dashboard />} />
        <Route path='/organizaciones/:id' element={<Dashboard />} />
        <Route path='/organizaciones/create-organizacion' element={<Dashboard />} />
        <Route path='/organizaciones/editar/:id' element={<Dashboard />} />
        <Route path='/opciones' element={<Dashboard />} />
        <Route path='/UploadForm' element={<UploadForm />} />
        {/* Ruta 404 */}
        <Route path='*' element={<NotFound />} />
      </Routes>

  )
}

export default App;
